import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={46}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={3} y={3} width={40} height={40} rx={20} fill={!props.isHover ? "#F2F4F7" : theme["#B4E3E1"]} />
            <path
                d="M14.666 19.981c0-.292 0-.438.013-.56a2.5 2.5 0 012.241-2.242c.123-.012.277-.012.584-.012.119 0 .178 0 .229-.003a1.667 1.667 0 001.445-1.042c.02-.047.037-.1.072-.205a3.88 3.88 0 01.071-.205 1.667 1.667 0 011.446-1.042c.05-.003.106-.003.217-.003h4.032c.11 0 .166 0 .217.003a1.667 1.667 0 011.445 1.042c.02.047.037.1.072.205.035.106.053.158.071.205.24.597.803 1.003 1.446 1.042.05.003.11.003.228.003.308 0 .462 0 .585.012a2.5 2.5 0 012.241 2.242c.012.122.012.268.012.56v6.52c0 1.4 0 2.1-.272 2.634a2.5 2.5 0 01-1.093 1.093c-.535.272-1.235.272-2.635.272h-8.666c-1.4 0-2.1 0-2.636-.272a2.5 2.5 0 01-1.092-1.093c-.273-.535-.273-1.235-.273-2.635v-6.519z"
                stroke={!props.isHover ? "#475467" : theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 26.75a3.333 3.333 0 100-6.666 3.333 3.333 0 000 6.666z"
                stroke={!props.isHover ? "#475467" : theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={3}
                y={3}
                width={40}
                height={40}
                rx={20}
                stroke={!props.isHover ? "#F9FAFB" : theme["#E7F6F5"]}
                strokeWidth={6}
            />
        </svg>
    )
}
  
  export default SvgComponent